{
  "app.name": "BRES",
  "common.save": "Opslaan",
  "common.saving": "Opslaan",
  "common.saved": "Opgeslagen",
  "common.cancel": "Annuleren",
  "common.close": "Sluiten",
  "common.back": "Terug",
  "common.edit": "Bewerken",
  "error.field.reference_taken": "Deze referentie bestaat al.",
  "common.delete": "Verwijderen",
  "common.remove": "Weghalen",
  "common.add": "Toevoegen",
  "common.create": "Aanmaken",
  "common.search": "Zoeken",
  "common.clear_search": "Zoekveld leegmaken",
  "common.filter": "Filter",
  "common.all": "Alle",
  "common.none": "Geen",
  "common.optional": "(optioneel)",
  "common.yes": "Ja",
  "common.no": "Nee",
  "common.retry": "Opnieuw proberen",
  "common.loading": "Laden",
  "common.more": "Meer",
  "common.actions": "Acties",
  "common.open": "Openen",
  "common.copy": "Kopiëren",
  "common.copied": "Gekopieerd",
  "common.view": "Bekijken",
  "common.download": "Downloaden",
  "common.select_all": "Alles selecteren",
  "common.selected": "{count, plural, one {# geselecteerd} other {# geselecteerd}}",
  "common.clear_selection": "Selectie opheffen",
  "common.results": "{count, plural, =0 {Geen resultaten} one {# resultaat} other {# resultaten}}",
  "common.load_more": "Meer laden",
  "common.unknown": "Onbekend",
  "common.never": "Nooit",
  "common.today": "Vandaag",
  "common.by": "door {name}",
  "common.version": "Versie {version}",
  "common.required": "Vul dit veld in",
  "common.notes": "Notities",
  "error.title": "Dit lukte niet",
  "error.page_not_found": "Pagina niet gevonden",
  "error.page_not_found_body": "Controleer het adres of ga terug naar het overzicht.",
  "error.back_to_overview": "Naar overzicht",
  "error.network": "Geen verbinding met de server. Je wijzigingen staan nog op het scherm; probeer het opnieuw.",
  "error.forbidden": "Je hebt hiervoor geen rechten in deze organisatie.",
  "error.not_found": "Dit bestaat niet (meer) of hoort bij een andere organisatie.",
  "error.validation": "Controleer de gemarkeerde velden.",
  "error.conflict": "Iemand anders heeft dit intussen gewijzigd.",
  "error.rate_limited": "Te veel verzoeken achter elkaar. Probeer het over een minuut opnieuw.",
  "error.server": "Er ging iets mis aan onze kant. Probeer het opnieuw.",
  "error.reference": "Referentie voor ondersteuning: {id}",
  "error.page_title": "Deze pagina kon niet laden",
  "error.code.version_conflict": "Iemand anders heeft dit intussen gewijzigd. Ververs om de nieuwste versie te zien.",
  "error.code.localization.test_output": "Dit is testuitvoer van de AI-testadapter, geen echte vertaling. Goedkeuren kan niet.",
  "error.code.localization.publish_incomplete": "Publiceren kan pas als titel en beschrijving van alle websitewoningen in die taal zijn goedgekeurd.",
  "error.code.localization.base_mismatch": "De versie waarop je voortbouwt hoort niet bij deze tekst en taal. Laad de huidige versie opnieuw.",
  "error.code.localization.source_changed": "De brontekst is gewijzigd sinds dit voorstel. Maak een nieuw voorstel.",
  "error.code.localization.qa_critical": "De feitencontrole vond een kritieke afwijking. Goedkeuren kan niet.",
  "error.code.localization.not_reviewable": "Deze versie is al beoordeeld of vervangen.",
  "error.code.localization.use_source_editor": "Dit is de brontaal. Pas de brontekst aan in de woning zelf.",
  "error.code.ai.budget_exceeded": "Het AI-budget van deze maand is op. Bestaande vertalingen blijven werken.",
  "error.code.ai.unavailable": "AI is nu niet beschikbaar. Vertaal handmatig of probeer het later.",
  "error.code.ai.unknown_locale": "Deze taal kent BRES nog niet.",
  "error.code.ai.unsupported_owner": "Alleen woningteksten kunnen nu via AI vertaald worden.",
  "error.code.ai.refused": "De AI-provider weigerde dit verzoek. Vertaal deze tekst handmatig.",
  "error.code.import.source_paused": "Deze importbron is gepauzeerd.",
  "error.code.import.upload_required": "Upload eerst een bestand voor deze bron.",
  "error.code.import.not_awaiting_review": "Deze importrun wacht niet meer op een besluit.",
  "error.code.import.source_changed": "De bron is gewijzigd sinds de review. Draai opnieuw een proefimport.",
  "error.code.import.mass_withdrawal_unconfirmed": "Veel woningen ontbreken in de bron. Bevestig de intrekkingen of wijs ze af.",
  "error.code.channel.kill_switch": "Dit portaal staat stil door de noodstop.",
  "error.code.channel.no_feed_adapter": "Voor dit portaal bestaat nog geen feedkoppeling.",
  "error.code.channel.no_publication": "Er is nog geen gepubliceerde versie om te exporteren.",
  "error.code.channel.status_requires_evidence": "Geaccepteerd of live kan pas met bewijs van het portaal zelf.",
  "error.code.media.order_mismatch": "De volgorde bevat niet precies alle beelden van deze woning. Ververs en probeer opnieuw.",
  "error.code.media.cover_must_be_photo": "Alleen een foto kan hoofdfoto zijn.",
  "error.code.restore.no_active_offer": "Die versie had geen actieve aanbieding.",
  "error.code.publication.no_locales": "Deze website heeft nog geen gepubliceerde taal.",
  "error.code.build.generation_mismatch": "De build hoort bij een andere publicatie. Ververs en probeer opnieuw.",
  "error.code.build.release_missing": "De build is geslaagd maar de release ontbreekt.",
  "nav.label": "Hoofdnavigatie",
  "nav.group_today": "Vandaag",
  "nav.group_clients": "Klanten",
  "nav.group_listings": "Aanbod",
  "nav.group_distribution": "Publicatie",
  "nav.group_system": "Systeem",
  "nav.overview": "Overzicht",
  "nav.leads": "Aanvragen",
  "nav.contacts": "Contacten",
  "nav.tasks": "Taken",
  "nav.properties": "Woningen",
  "nav.localization": "Talen",
  "nav.website": "Website",
  "nav.channels": "Portalen",
  "nav.imports": "Imports",
  "nav.ai": "AI-assistent",
  "nav.settings": "Instellingen",
  "nav.open_menu": "Menu openen",
  "nav.breadcrumbs": "Kruimelpad",
  "shell.search": "Zoeken of springen naar…",
  "shell.search_label": "Zoeken en navigeren",
  "shell.command_placeholder": "Zoek een woning, scherm of actie",
  "shell.command_empty": "Niets gevonden. Probeer een referentie zoals TB-4127.",
  "shell.command_group_pages": "Schermen",
  "shell.command_group_properties": "Woningen",
  "shell.command_group_actions": "Acties",
  "shell.command_hint_open": "openen",
  "shell.command_hint_move": "kiezen",
  "shell.command_hint_close": "sluiten",
  "shell.action_new_property": "Nieuwe woning",
  "shell.action_publish": "Website publiceren",
  "shell.action_theme": "Licht of donker wisselen",
  "shell.switch_org": "Organisatie wisselen",
  "shell.org_label": "Organisatie",
  "shell.demo": "Demo",
  "shell.demo_hint": "Fictieve gegevens; berichten gaan naar een lokale testmailbox.",
  "shell.user_menu": "Accountmenu",
  "shell.language": "Taal van het beheer",
  "shell.theme": "Weergave",
  "shell.theme_system": "Zoals systeem",
  "shell.theme_light": "Licht",
  "shell.theme_dark": "Donker",
  "shell.sign_out": "Uitloggen",
  "shell.signed_out": "Je bent uitgelogd",
  "shell.toasts": "Meldingen",
  "shell.support_access": "Ondersteuningstoegang tot {date}",
  "shell.no_membership_title": "Nog geen toegang",
  "shell.no_membership_body": "Je account is nog niet aan een organisatie gekoppeld. Vraag een beheerder om je uit te nodigen.",
  "login.title": "Inloggen bij BRES",
  "login.email": "E-mailadres",
  "login.password": "Wachtwoord",
  "login.submit": "Inloggen",
  "login.failed": "E-mailadres of wachtwoord klopt niet.",
  "login.totp_title": "Bevestig met je authenticator-app",
  "login.totp_code": "Code van 6 cijfers",
  "login.totp_submit": "Bevestigen",
  "login.totp_failed": "Deze code klopt niet of is verlopen.",
  "login.demo": "Lokale demo: de logins staan in var/demo-accounts.txt.",
  "role.owner": "Eigenaar",
  "role.admin": "Beheerder",
  "role.agent": "Makelaar",
  "role.editor": "Redacteur",
  "role.reviewer": "Taalreviewer",
  "role.viewer": "Meekijker",
  "kind.apartment": "Appartement",
  "kind.penthouse": "Penthouse",
  "kind.duplex": "Duplex",
  "kind.studio": "Studio",
  "kind.townhouse": "Rijtjeshuis",
  "kind.semi_detached": "Twee-onder-een-kap",
  "kind.detached_house": "Vrijstaand huis",
  "kind.villa": "Villa",
  "kind.bungalow": "Bungalow",
  "kind.finca": "Finca",
  "kind.country_house": "Landhuis",
  "kind.cave_house": "Grotwoning",
  "kind.plot": "Bouwgrond",
  "kind.commercial": "Bedrijfspand",
  "kind.garage": "Garage",
  "kind.other": "Overig",
  "offer.sale": "Te koop",
  "offer.long_let": "Te huur",
  "offer.holiday_let": "Vakantieverhuur",
  "status.available": "Beschikbaar",
  "status.reserved": "Gereserveerd",
  "status.sold": "Verkocht",
  "status.let": "Verhuurd",
  "status.withdrawn": "Ingetrokken",
  "editorial.draft": "Concept",
  "editorial.ready": "Klaar",
  "editorial.archived": "Gearchiveerd",
  "lead.status.new": "Nieuw",
  "lead.status.contacted": "Contact gehad",
  "lead.status.qualified": "Gekwalificeerd",
  "lead.status.viewing": "Bezichtiging",
  "lead.status.offer": "Bod",
  "lead.status.won": "Gewonnen",
  "lead.status.lost": "Verloren",
  "lead.status.spam": "Spam",
  "lead.kind.property_enquiry": "Vraag over woning",
  "lead.kind.general": "Algemene vraag",
  "lead.kind.viewing_request": "Bezichtigingsverzoek",
  "lead.kind.seller_intake": "Verkoper",
  "lead.kind.shortlist_reply": "Reactie op selectie",
  "build.status.queued": "In de wachtrij",
  "build.status.running": "Bezig",
  "build.status.succeeded": "Gelukt",
  "build.status.promoted": "Live",
  "build.status.failed": "Mislukt",
  "build.status.checks_failed": "Controles afgekeurd",
  "build.status.superseded": "Ingehaald",
  "build.status.cancelled": "Geannuleerd",
  "channel.production": "Productie",
  "channel.preview": "Preview",
  "priority.low": "Laag",
  "priority.normal": "Normaal",
  "priority.high": "Hoog",
  "priority.urgent": "Dringend",
  "audit.task.updated": "Taak bijgewerkt",
  "audit.task.created": "Taak aangemaakt",
  "audit.site.rolled_back": "Website teruggezet",
  "audit.site.promoted": "Websiteversie beschikbaar",
  "audit.site.emergency_withdrawal": "Woning direct van de website gehaald",
  "audit.site.build_superseded": "Build ingehaald door nieuwere",
  "audit.site.build_failed": "Websitebuild mislukt",
  "audit.shortlist.shared": "Selectie gedeeld",
  "audit.shortlist.share_revoked": "Deellink ingetrokken",
  "audit.shortlist.created": "Selectie gemaakt",
  "audit.rights.revoked": "Recht ingetrokken",
  "audit.rights.granted": "Recht vastgelegd",
  "audit.publication.created": "Publicatie gestart",
  "audit.property.updated": "Woning gewijzigd",
  "audit.property.duplicated": "Woning gedupliceerd",
  "audit.property.created": "Woning aangemaakt",
  "audit.note.added": "Notitie toegevoegd",
  "audit.media.rights_updated": "Beeldrechten bijgewerkt",
  "audit.media.reordered": "Foto's opnieuw geordend",
  "audit.media.removed": "Beeld verwijderd",
  "audit.media.cover_set": "Hoofdfoto gekozen",
  "audit.media.added": "Beeld toegevoegd",
  "audit.localization.proposed": "Vertaling voorgesteld",
  "audit.localization.approve": "Vertaling goedgekeurd",
  "audit.localization.reject": "Vertaling afgekeurd",
  "audit.localization.request_changes": "Wijzigingen gevraagd in vertaling",
  "audit.localization.term_saved": "Term opgeslagen",
  "audit.localization.term_deleted": "Term verwijderd",
  "audit.locale.profile_saved": "Taalprofiel opgeslagen",
  "audit.site.locales_saved": "Talen van de website opgeslagen",
  "audit.appointment.created": "Afspraak gemaakt",
  "audit.contact.updated": "Contact bijgewerkt",
  "audit.contact.archived": "Contact gearchiveerd",
  "audit.contact.restored": "Contact teruggezet",
  "audit.brief.updated": "Woonwens bijgewerkt",
  "audit.brief.status_changed": "Status woonwens gewijzigd",
  "audit.appointment.updated": "Afspraak bijgewerkt",
  "audit.appointment.status_changed": "Afspraakstatus gewijzigd",
  "audit.organization.updated": "Organisatie bijgewerkt",
  "audit.organization.created": "Organisatie aangemaakt",
  "audit.area.created": "Gebied toegevoegd",
  "audit.area.updated": "Gebied bijgewerkt",
  "audit.area.deleted": "Gebied verwijderd",
  "audit.import.source_created": "Importbron toegevoegd",
  "audit.import.source_updated": "Importbron gewijzigd",
  "audit.media.alt_saved": "Alt-tekst opgeslagen",
  "audit.ai.budget_set": "AI-budget ingesteld",
  "audit.team.member_updated": "Teamlid gewijzigd",
  "audit.lead.received": "Aanvraag ontvangen",
  "audit.lead.updated": "Aanvraag bijgewerkt",
  "audit.import.started": "Import gestart",
  "audit.import.rejected": "Import afgewezen",
  "audit.import.failed": "Import mislukt",
  "audit.import.diffed": "Importverschillen klaar",
  "audit.import.applied": "Import toegepast",
  "audit.field.unlocked": "Veld ontgrendeld",
  "audit.field.locked": "Veld vergrendeld",
  "audit.contact.created": "Contact aangemaakt",
  "audit.channel.updated": "Portaalinstelling gewijzigd",
  "audit.channel.feed_generated": "Portaalfeed gemaakt",
  "audit.brief.created": "Woonwens vastgelegd",
  "audit.ai.localize": "AI-vertaling gevraagd",
  "audit.ai.eval_case": "AI-evaluatie uitgevoerd",
  "actor.system": "Systeem",
  "actor.platform": "BRES-platform",
  "actor.build": "Websitebuild",
  "actor.website": "Website",
  "actor.import": "Import",
  "actor.unknown": "Onbekend",
  "feature.private_pool": "Privézwembad",
  "feature.communal_pool": "Gemeenschappelijk zwembad",
  "feature.garden": "Tuin",
  "feature.terrace": "Terras",
  "feature.balcony": "Balkon",
  "feature.roof_terrace": "Dakterras",
  "feature.garage": "Garage",
  "feature.parking": "Parkeerplaats",
  "feature.storage_room": "Berging",
  "feature.lift": "Lift",
  "feature.air_conditioning": "Airconditioning",
  "feature.heating": "Verwarming",
  "feature.solar_panels": "Zonnepanelen",
  "feature.fireplace": "Open haard",
  "feature.fitted_kitchen": "Ingerichte keuken",
  "feature.furnished": "Gemeubileerd",
  "feature.barbecue": "Barbecue",
  "feature.gated_community": "Afgesloten complex",
  "feature.sea_front": "Aan zee",
  "feature.near_beach": "Bij het strand",
  "feature.near_golf": "Bij golfbaan",
  "feature.wheelchair_accessible": "Rolstoeltoegankelijk",
  "feature.fibre_internet": "Glasvezel",
  "feature.water_deposit": "Watertank",
  "feature.guest_apartment": "Gastenverblijf",
  "feature.tourist_license": "Toeristische vergunning",
  "view.sea": "Zeezicht",
  "view.mountain": "Bergzicht",
  "view.teide": "Zicht op de Teide",
  "view.golf": "Golfzicht",
  "view.pool": "Zicht op zwembad",
  "view.garden": "Tuinzicht",
  "view.city": "Stadszicht",
  "view.countryside": "Landelijk zicht",
  "orientation.n": "Noord",
  "orientation.ne": "Noordoost",
  "orientation.e": "Oost",
  "orientation.se": "Zuidoost",
  "orientation.s": "Zuid",
  "orientation.sw": "Zuidwest",
  "orientation.w": "West",
  "orientation.nw": "Noordwest",
  "energy.status.certified": "Gecertificeerd",
  "energy.status.in_progress": "Certificaat in aanvraag",
  "energy.status.exempt": "Vrijgesteld",
  "energy.status.unknown": "Onbekend",
  "precision.street": "Straat",
  "precision.area": "Gebied",
  "precision.municipality": "Gemeente",
  "precision.hidden": "Verborgen",
  "ownership.own": "Eigen aanbod",
  "ownership.partner": "Partneraanbod",
  "ownership.development": "Nieuwbouwproject",
  "rights.source.own_photography": "Eigen fotografie",
  "rights.source.owner_supplied": "Aangeleverd door eigenaar",
  "rights.source.stock_license": "Stocklicentie",
  "rights.source.partner_feed": "Partnerfeed",
  "rights.source.generated": "Gegenereerd beeld",
  "rights.source.unknown": "Onbekend",
  "rights.scope.website": "Website",
  "rights.scope.portal": "Portalen",
  "rights.scope.network": "Netwerk",
  "rights.basis.mandate": "Opdracht (mandaat)",
  "rights.basis.owner_consent": "Toestemming eigenaar",
  "rights.basis.source_license": "Licentie van de bron",
  "rights.basis.partner_agreement": "Partnerovereenkomst",
  "period.month": "per maand",
  "period.week": "per week",
  "period.night": "per nacht",
  "shell.density": "Dichtheid",
  "shell.density_comfortable": "Ruim",
  "shell.density_compact": "Compact",
  "shell.theme_switch": "Weergave kiezen",
  "shell.shortcuts": "Sneltoetsen",
  "shell.shortcuts_lead": "Werkt overal behalve in invoervelden.",
  "shell.shortcut_search": "Zoeken of springen naar",
  "shell.shortcut_help": "Dit overzicht",
  "shell.shortcut_go": "Naar {page}",
  "shell.shortcut_then": "dan",
  "shell.loading": "Bezig met laden",
  "login.lead": "Gebruik het e-mailadres van je werkaccount.",
  "login.art_title": "Je kantoor, van aanbod tot website.",
  "login.art_lead": "Woningen beheren, aanvragen opvolgen, teksten vertalen en publiceren naar je site en portalen.",
  "shell.command_group_recent": "Recent geopend",
  "nav.group_platform": "Platform",
  "nav.platform_dashboard": "Dashboard",
  "nav.platform_sites": "Sites en SEO",
  "shell.platform_name": "BRES-platform",
  "shell.platform_role": "Platformbeheer",
  "shell.platform_label": "Platform",
  "shell.clients_label": "Klanten",
  "shell.support_until": "toegang tot {date}",
  "shell.command_group_platform": "Platform",
  "nav.blog": "Blog",
  "nav.chat": "Chatbot",
  "nav.group_bres_site": "BRES-website",
  "nav.platform_ai": "AI-opties",
  "nav.platform_bres_blog": "Blog",
  "nav.platform_bres_chat": "Chatbot",
  "common.clear": "Wissen",
  "error.code.ai.not_in_plan": "Deze AI-functie zit niet in het abonnement van deze organisatie of site.",
  "error.code.blog.checks_blocking": "Los eerst de blokkerende punten in de controles op.",
  "error.code.blog.test_output": "Er staat nog uitvoer van de testadapter in. Herschrijf de tekst voordat je goedkeurt.",
  "error.code.blog.locale_locked": "Deze taalversie ligt ter review of is goedgekeurd. Vraag eerst wijzigingen aan.",
  "error.code.blog.archived": "Dit artikel is gearchiveerd.",
  "error.code.blog.not_draft": "Alleen een concept kan ter review.",
  "error.code.blog.not_in_review": "Deze taalversie ligt niet ter review.",
  "error.code.blog.locale_published": "Deze taalversie is al gepubliceerd en kan niet uit de brief.",
  "error.code.blog.slug_taken": "Er is geen vrije slug gevonden.",
  "error.code.chat.unavailable": "De chatbot is niet beschikbaar op deze site.",
  "audit.ai.entitlement_changed": "AI-functie gewijzigd door BRES",
  "audit.ai.cap_changed": "AI-plafond gewijzigd door BRES",
  "audit.ai.feature_requested": "Interesse in AI-functie doorgegeven",
  "audit.blog.brief_created": "Blogbrief gemaakt",
  "audit.blog.brief_updated": "Blogbrief bijgewerkt",
  "audit.blog.archived": "Artikel gearchiveerd",
  "audit.blog.restored": "Artikel hersteld als concept",
  "audit.blog.ai_draft": "AI-concept gemaakt",
  "audit.blog.edited": "Artikel bewerkt",
  "audit.blog.approval_cleared": "Goedkeuring vervallen door wijziging",
  "audit.blog.submitted": "Ter review aangeboden",
  "audit.blog.approved": "Taalversie goedgekeurd",
  "audit.blog.request_changes": "Wijzigingen gevraagd",
  "audit.blog.reject": "Taalversie afgewezen",
  "audit.blog.source_created": "Bron toegevoegd",
  "audit.blog.source_updated": "Bron bijgewerkt",
  "audit.blog.category_saved": "Blogcategorie opgeslagen",
  "audit.chat.settings_saved": "Chatbotinstellingen opgeslagen",
  "audit.chat.handoff": "Chatgesprek doorgezet naar aanvraag",
  "audit.chat.knowledge_created": "Chatkennis toegevoegd",
  "audit.chat.knowledge_updated": "Chatkennis bijgewerkt",
  "audit.chat.knowledge_deleted": "Chatkennis verwijderd",
  "audit.chat.purged": "Chatgesprekken na de bewaartermijn opgeschoond",
  "audit.team.invited": "Teamlid uitgenodigd",
  "audit.team.invitation_revoked": "Uitnodiging ingetrokken",
  "audit.team.joined": "Teamlid toegetreden",
  "access.title": "Toegang nemen tot {name}?",
  "access.body": "Je krijgt beheerdersrechten bij deze klant als BRES-ondersteuning. De klant ziet je in het team en in het auditlog.",
  "access.confirm": "Toegang nemen en openen",
  "access.failed": "Toegang nemen lukte niet",
  "access.take": "Toegang nemen",
  "access.none": "Nog geen toegang",
  "audit.team.support_granted": "BRES-ondersteuning kreeg toegang",
  "audit.team.member_revoked": "Teamtoegang ingetrokken",
  "audit.module.requested": "Interesse in een module doorgegeven",
  "audit.module.entitlement_changed": "Module gewijzigd door BRES",
  "audit.secret.created": "Geheim opgeslagen",
  "audit.secret.rotated": "Geheim vernieuwd",
  "audit.secret.revoked": "Geheim ingetrokken",
  "audit.reputation.connection_created": "Koppeling met een reviewbron gestart",
  "audit.reputation.authorized": "Ingelogd bij een reviewbron",
  "audit.reputation.keys_validated": "Sleutel van een reviewbron gecontroleerd",
  "audit.reputation.locations_saved": "Locaties van een reviewbron gekoppeld",
  "audit.reputation.synced": "Reviews opgehaald",
  "audit.reputation.sync_failed": "Reviews ophalen mislukt",
  "audit.reputation.needs_reauth": "Reviewbron vraagt opnieuw inloggen",
  "audit.reputation.connection_paused": "Reviewbron gepauzeerd",
  "audit.reputation.connection_resumed": "Reviewbron hervat",
  "audit.reputation.disconnected": "Reviewbron ontkoppeld",
  "audit.reputation.access_revoked": "Toegang tot reviewbron ingetrokken",
  "audit.reputation.webhook_created": "Webhookadres voor reviews gemaakt",
  "audit.reputation.reply_consent_given": "Toestemming om antwoorden te plaatsen vastgelegd",
  "audit.reputation.reply_consent_withdrawn": "Toestemming om antwoorden te plaatsen ingetrokken",
  "audit.reputation.reply_queued": "Antwoord op review in de wachtrij",
  "audit.reputation.reply_posted": "Antwoord op review geplaatst",
  "audit.reputation.published": "Eigen reviews gepubliceerd na de wachttijd",
  "audit.reputation.purged": "Reviewgegevens opgeschoond na de bewaartermijn",
  "audit.reputation.experience_recorded": "Ervaring vastgelegd",
  "audit.reputation.experiences_imported": "Ervaringen geïmporteerd",
  "audit.reputation.invitation_planned": "Reviewuitnodiging gepland",
  "audit.reputation.invitation_sent": "Reviewuitnodiging verstuurd",
  "audit.reputation.invitation_skipped": "Reviewuitnodiging overgeslagen",
  "audit.reputation.invitation_resent": "Reviewuitnodiging opnieuw verstuurd",
  "audit.reputation.unsubscribed": "Afgemeld voor reviewverzoeken",
  "audit.reputation.review_submitted": "Eigen review ingediend",
  "audit.reputation.moderated": "Review gemodereerd",
  "audit.reputation.reported": "Review gemeld door een bezoeker",
  "audit.reputation.report_decided": "Melding van een review afgehandeld",
  "audit.reputation.rule_changed": "Uitnodigregel gewijzigd",
  "audit.reputation.settings_changed": "Reviewweergave van de site gewijzigd",
  "audit.reputation.translated": "Review automatisch vertaald",
  "audit.reputation.imported": "Eerder gepubliceerde reviews overgenomen",
  "audit.reputation.reply_suggested": "Antwoordvoorstel gemaakt",
  "audit.reputation.screened": "Review gescreend",
  "audit.reputation.themes": "Terugkerende onderwerpen samengevat",
  "nav.platform_reviews": "Reviews",
  "audit.reputation.themes_analyzed": "Thema's van reviews bepaald",
  "audit.reputation.display_changed": "Weergave van reviews gewijzigd",
  "audit.reputation.invitation_retried": "Reviewuitnodiging opnieuw ingepland",
  "audit.reputation.moderation_release": "Review vrijgegeven",
  "audit.reputation.moderation_reject": "Review niet gepubliceerd",
  "audit.reputation.legacy_imported": "Eerder gepubliceerde reviews overgenomen",
  "audit.reputation.moderation_hold": "Review vastgehouden",
  "audit.reputation.moderation_mark_before_change": "Review gemarkeerd als van vóór een wijziging",
  "audit.reputation.google_place_set": "Google-bedrijf gekoppeld",
  "audit.reputation.google_place_removed": "Google-bedrijf losgekoppeld",
  "audit.reputation.google_location_set": "Google-bedrijf gekoppeld",
  "audit.reputation.google_location_removed": "Google-bedrijf van de site gehaald",
  "audit.reputation.google_links_set": "Knop naar Google ingesteld",
  "audit.reputation.google_links_removed": "Knop naar Google verwijderd",
  "shell.support_access_open": "Ondersteuningstoegang als BRES-beheer"
}
